import React from "react";
import { STUDIOS } from "./studioRegistry";
import StudioCard from "./components/StudioCard";
import "./studiosScreen.css";
import AppScreenWrapper from '../../../components/app-shell/AppScreenWrapper';
import Sidebar from '../../../components/app-shell/Sidebar';
import Topbar from '../../../components/app-shell/Topbar';
import ScreenOrbs from '../../../components/app-shell/ScreenOrbs';
import useClientData from '../../../hooks/useClientData';

export default function StudiosHomeScreen() {
  const { balance, clientName, clientEmail } = useClientData();

  return (
    <AppScreenWrapper>
      <div className="screen-root" style={{ display: 'flex' }}>
        <Sidebar balance={balance} name={clientName} email={clientEmail} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, position: 'relative' }}>
          <ScreenOrbs tone="purple" />
          <Topbar title="Studios" name={clientName} />

          <div className="scroll-y" style={{ flex: 1, padding: '32px', position: 'relative', zIndex: 1 }}>
            <div className="studios-home-header" style={{ marginBottom: 32 }}>
              <h1 style={{ fontSize: 24, fontWeight: 700, margin: 0 }}>Studios</h1>
              <p style={{ color: 'var(--text-3)', marginTop: 8, marginBottom: 0 }}>
                Bespoke AI workspaces for specific creative tasks. Each Studio is a
                curated pipeline — pick one to start creating.
              </p>
            </div>
            <div className="studios-home-grid">
              {STUDIOS.map((studio) => (
                <StudioCard key={studio.slug} studio={studio} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </AppScreenWrapper>
  );
}
